export default {
  title: 'Ordredetaljer',
};
